import { Formik } from "formik";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { injectIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { format } from "date-fns";
import * as petsActions from "../../_redux/pets";
import { toast } from "react-toastify";

import Modal from "../../../../../_artifact/components/Modal";
import {
  catchUIError,
  saveResponseToServer,
  submitAnswers,
  getRewardLink,
  updateQuestionnaires,
} from "../../_redux/pets";
import { translate } from "../../../../../_artifact/i18n";
import jsonHelper from "../../../../../_artifact/helpers/jsonHelper";
import { trackingLog } from "../../../Tracking/_redux/tracking";

const questionTypeClasses = {
  radio: "first",
  scale: "space-between",
};

const questionTypeTitles = {
  radio: "radio",
  scale: "scale",
  checkbox: "check box",
};

function PostFeedQuestionnaire({ intl, history }) {
  const { state } = useSelector((state) => ({ state }), shallowEqual);
  const { questionnaires } = state.pets.entities;
  const dispatch = useDispatch();
  const [que, setQue] = useState(null);
  const [isSubmittedOpen, setIsSubmittedOpen] = useState(false);
  const [rewardURL, setRewardURL] = useState("");
  const isSubmitted = useRef(0);
  const [isOpen, setIsOpen] = useState(false);
  const { trackingPayload } = useSelector(
    (state) => state.tracking,
    shallowEqual
  );
  const { panelist_email_id, country } = state.auth.user;
  const [retryReward, setRetryReward] = useState(false);
  const [retrying, setRetrying] = useState(false);
  const [retryObj, setRetryObj] = useState(null);

  const tryRewardFetch = useCallback(
    async (obj) => {
      setRetryObj(obj);
      setRetrying(true);
      try {
        const response = await dispatch(petsActions.getRewardLink(obj));
        const status = response?.data?.status?.toLowerCase?.();
        const url = response?.data?.url;
        if (status === "success") {
          setRewardURL(url);
          setRetryReward(false);
          setIsOpen(true); //Open final success modal
        } else {
          setRetryReward(true); //Keep showing retry modal
          toast.error(translate("TESTING.GENERAL.RETRY_REWARD", intl));
        }
      } catch (error) {
        setRetryReward(true); //Show retry modal on API error
      } finally {
        setRetrying(false);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const getQuens = localStorage.getItem("allQuestions");
    const myObject = JSON.parse(getQuens).filter(
      (item) => item.post_feed === 1
    );
    setQue(myObject);
    localStorage.setItem("question", JSON.stringify(myObject));
  }, []);

  const getQuestionClasses = (question_type, valid_answer) => {
    let classes = questionTypeClasses[question_type];
    if (
      question_type === questionTypeTitles.scale &&
      valid_answer.range[1] <= 5
    ) {
      classes += " large";
    }
    return classes;
  };
  const updateQuestions = (answer, index, type = "radio") => {
    const newQuestions = JSON.parse(JSON.stringify(que));

    if (type === questionTypeTitles.checkbox) {
      let existing = newQuestions[index].response || [];
      if (existing.includes(answer)) {
        existing = existing.filter((a) => a !== answer);
      } else {
        existing.push(answer);
      }
      newQuestions[index].response = existing;
    } else {
      newQuestions[index].response = answer;
    }

    setQue(newQuestions);
    localStorage.setItem("question", JSON.stringify(newQuestions));
    dispatch(updateQuestionnaires(newQuestions));
  };

  const onSubmit = ({ questionnaires, comment }) => {
    if (isSubmitted.current) return;
    //if que is null, then default will be an empty array
    const unanswered = (que || []).filter((q) => {
      if (q.question_type === questionTypeTitles.checkbox) {
        //if it is not an array or if it is an empty array
        return !Array.isArray(q.response) || q.response.length === 0;
      }
      //for radio or scale type if the response is undefined/null or empty string
      return (
        q.response === undefined || q.response === null || q.response === ""
      );
    });

    if (unanswered.length > 0) {
      alert("Please answer all the questions before submitting.");
      return;
    }

    isSubmitted.current = 1;
    const jsonString = localStorage.getItem("selectedTest");
    const selectedTest = JSON.parse(jsonString);
    const getQuens = localStorage.getItem("question");
    const myObject = JSON.parse(getQuens);
    const responses = myObject?.map(
      ({ question_id, title, response, question_type }) => ({
        question_id,
        title,
        question_type,
        response:
          question_type === questionTypeTitles.checkbox
            ? Array.isArray(response)
              ? response
              : [response]
            : String(response),
      })
    );
    dispatch(submitAnswers({ responses, comment }));
    const now = new Date().toISOString();
    let endTime = now;
    const startTime = localStorage.getItem("postWeightStartTime");
    localStorage.setItem("end_time", endTime);

    const ques_res = responses.reduce(
      (acc, { question_id, response, question_type }) => {
        acc[question_id] =
          question_type === questionTypeTitles.checkbox
            ? Array.isArray(response)
              ? response
              : [response]
            : String(response);
        return acc;
      },
      {}
    );
    const jsonAnswer = JSON.stringify(ques_res);
    localStorage.setItem("answer", jsonAnswer);
    localStorage.setItem("comment", comment || "");

    const values = {
      panelist_id: selectedTest.panelist_id,
      test_schedule_id: selectedTest.test_schedule_id,
      product_id: selectedTest.product_id,
      question_response: jsonAnswer,
      add_comments: comment,
      start_time: format(new Date(startTime), "yyyy-MM-dd HH:mm:ss"),
      end_time: format(new Date(endTime), "yyyy-MM-dd HH:mm:ss"),
      post_feed: 1,
      panelist_email_id: panelist_email_id,
      species: selectedTest.species,
      product_category: selectedTest.product_category,
      country: country,
    };
    const api = () => {
      dispatch(saveResponseToServer(jsonHelper.jsonToForm(values)))
        .then(() => {
          dispatch(
            trackingLog({
              ...trackingPayload,
              question_responses: jsonAnswer,
              postweight_page: 1,
            })
          );
          //setIsOpen(true);
          let obj = {
            panelist_email_id: panelist_email_id,
            test_id: selectedTest?.test_name,
            product_id: selectedTest?.product_id,
          };
          tryRewardFetch(obj);
          // dispatch(getRewardLink(obj)).then((response) => {
          //   const rewardURL = response?.data?.url;
          //   setRewardURL(rewardURL);
          // });
        })
        .catch((error) => {
          error.clientMessage = translate(
            "TESTING.TOAST.TEST_SUBMIT_FAILED",
            intl
          );
          dispatch(catchUIError(error));
          isSubmitted.current = 0;
        });
    };

    api();
  };

  return (
    <div className="inner-page">
      <Formik
        initialValues={{ questionnaires: que, comment: "" }}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, handleSubmit }) => (
          <div className="test-box">
            <h3 className="test-box-title desktop-only">
              <i className="icon-eye"></i>
              {translate("TESTING.GENERAL.OBSERVE_YOUR_PET_REVIEW", intl)}
            </h3>
            <p className="text-center mobile-only">
              {translate("TESTING.GENERAL.OBSERVE_YOUR_PET_REVIEW", intl)}
            </p>
            <div className="q-instruction-wrap">
              <span className="q-instruction">
                {translate("TESTING.GENERAL.POST_FEED_QUESTIONS", intl)}
              </span>
            </div>

            <div className="question-wrap">
              <dl className="questions-list">
                {que?.map(
                  (
                    {
                      question_id,
                      title,
                      question,
                      question_type,
                      valid_answer,
                      response,
                    },
                    index
                  ) => (
                    <div key={question_id}>
                      <dt>
                        <strong>
                          {index + 1}. {title}:
                        </strong>{" "}
                        {question}
                      </dt>
                      <dd>
                        <ul
                          className={`question-options ${getQuestionClasses(
                            question_type,
                            valid_answer
                          )}`}
                        >
                          {question_type === questionTypeTitles.radio &&
                            valid_answer.map((answer, answerIndex) => (
                              <li key={answerIndex} className="checkbox-item">
                                <div>
                                  <input
                                    type="radio"
                                    name={question_id}
                                    checked={response === answerIndex + 1}
                                    onChange={() => {
                                      setFieldValue(
                                        `questionnaires[${index}].response`,
                                        answerIndex + 1
                                      );
                                      updateQuestions(answerIndex + 1, index);
                                    }}
                                  />
                                  <label>{answerIndex + 1}.</label>
                                </div>
                                <span>{answer}</span>
                              </li>
                            ))}

                          {question_type === questionTypeTitles.scale &&
                            _.range(
                              valid_answer.range[0],
                              valid_answer.range[1] + 1
                            ).map((answer) => (
                              <li key={answer} className="checkbox-item">
                                <div>
                                  <input
                                    type="radio"
                                    name={question_id}
                                    checked={response === answer}
                                    onChange={() => {
                                      setFieldValue(
                                        `questionnaires[${index}].response`,
                                        answer
                                      );
                                      updateQuestions(answer, index);
                                    }}
                                  />
                                  <label>{answer}</label>
                                </div>
                              </li>
                            ))}
                          <div className="checkbox-wrapper">
                            {question_type === questionTypeTitles.checkbox &&
                              valid_answer.map((answer, answerIndex) => (
                                <li key={answerIndex} className="checkbox-item">
                                  <div className="checkbox-header">
                                    <input
                                      type="checkbox"
                                      name={`${question_id}-${answerIndex}`}
                                      checked={response?.includes(
                                        answerIndex + 1
                                      )}
                                      onChange={() => {
                                        const newResponse = response || [];
                                        setFieldValue(
                                          `questionnaires[${index}].response`,
                                          newResponse
                                        );
                                        updateQuestions(
                                          answerIndex + 1,
                                          index,
                                          questionTypeTitles.checkbox
                                        );
                                      }}
                                    />
                                  </div>
                                  <div>{answer}</div>
                                </li>
                              ))}
                          </div>
                        </ul>
                        {question_type === questionTypeTitles.scale && (
                          <div className="answer-suggestion">
                            <span>{valid_answer.least}</span>
                            <span>{valid_answer.greatest}</span>
                          </div>
                        )}
                      </dd>
                    </div>
                  )
                )}
              </dl>

              <div className="form-group">
                <label>{translate("TESTING.GENERAL.ISSUES", intl)}</label>
                <textarea
                  placeholder={translate("TESTING.GENERAL.OTHER_ISSUES", intl)}
                  rows="5"
                  className="form-control"
                  onChange={(e) => setFieldValue("comment", e.target.value)}
                ></textarea>
              </div>

              <button
                className="btn btn-primary btn-block"
                onClick={handleSubmit}
              >
                {translate("TESTING.BUTTON.SUBMIT", intl)}
              </button>
            </div>
          </div>
        )}
      </Formik>

      <Modal
        isOpen={isOpen}
        action={
          country.toLowerCase() === "usa"
            ? translate("APP.BUTTON.RR", intl)
            : translate("APP.BUTTON.OK", intl)
        }
        title={translate("TESTING.GENERAL.YOUR_TEST_WAS_SUCCESSFUL", intl)}
        onClose={() => {
          setIsOpen(false);
          if (country.toLowerCase() === "usa") {
            window.open(rewardURL, "_blank");
            history.replace("/");
          } else {
            history.replace("/");
          }
        }}
      />
      {country.toLowerCase() === "usa" && (
        <Modal
          isOpen={retryReward}
          title={translate("TESTING.TOAST.GENERATE_REWARD_LINK", intl)}
          icon="icon-circle-x text-danger font-200"
          disable={true}
          action={
            <button
              className="btn btn-primary"
              onClick={() => {
                if (retryObj) {
                  tryRewardFetch(retryObj); // Try again using saved params
                }
              }}
              disabled={retrying}
            >
              {retrying
                ? translate("RETRYING", intl)
                : translate("RETRY", intl)}
            </button>
          }
          onClose={() => {
            // Optional: prevent closing until success
            setRetryReward(true);
          }}
        />
      )}
    </div>
  );
}

export default injectIntl(PostFeedQuestionnaire);
